exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__loginContainer___1BgGn{max-width:80rem;min-height:18rem;margin:0 auto;text-align:center}.style__beginLoginButton___2OSsg{display:inline-block;margin:0 auto;margin-top:3rem}.style__gButton___3ciCR{margin:0 auto;width:120px}", "", {"version":3,"sources":["/./containers/publicHome/style.css"],"names":[],"mappings":"AAAA,+BACC,gBAAiB,AACjB,iBAAkB,AAClB,cAAe,AACf,iBAAmB,CACnB,AAED,iCACC,qBAAsB,AACtB,cAAe,AACf,eAAiB,CACjB,AAED,wBACC,cAAe,AACf,WAAa,CACb","file":"style.css","sourcesContent":[".loginContainer {\n\tmax-width: 80rem;\n\tmin-height: 18rem;\n\tmargin: 0 auto;\n\ttext-align: center;\n}\n\n.beginLoginButton {\n\tdisplay: inline-block;\n\tmargin: 0 auto;\n\tmargin-top: 3rem;\n}\n\n.gButton {\n\tmargin: 0 auto;\n\twidth: 120px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"loginContainer": "style__loginContainer___1BgGn",
	"beginLoginButton": "style__beginLoginButton___2OSsg",
	"gButton": "style__gButton___3ciCR"
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!/data/www/SGDBackend-Nex2/~/postcss-loader!./containers/publicHome/style.css
// module id = 564
// module chunks = 0